import { render, staticRenderFns } from "./Release520.vue?vue&type=template&id=409c2a75&"
import script from "./Release520.vue?vue&type=script&lang=js&"
export * from "./Release520.vue?vue&type=script&lang=js&"
import style0 from "./Release520.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports